<template>
  <nav class="navbar navbar-expand-lg" color-on-scroll="500">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/">
        <img style="margin-top: -19px;" src="assets/img/logo.png" />
      </router-link>

      <div class="collapse navbar-collapse justify-content-end" id="navigation">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <button @click="logOut" class="btn btn-info">
              <span class="glyphicon glyphicon-log-out"></span> Log out
             </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  methods :{
    logOut() {
      sessionStorage.clear();
      this.$router.push('/login');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
